class WebSocketService {
  constructor() {
    this.socket = null;
    this.messageCallback = null;
    this.senderUsername = null; // Track the sender's username
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 1000; // Start with 1 second
  }

  connect(accessToken, receiverId) {
    if (this.socket) {
      this.socket.close();
    }

    const url = `${process.env.REACT_APP_WEBSOCKET_URL}/ws/chat/${encodeURIComponent(receiverId)}/?token=${accessToken}`;
    console.log(`Connecting to WebSocket at URL: ${url}`);

    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log('WebSocket connected');
      // console.log(url);
    };

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      // console.log('WebSocket message received:', data);
      
      // Ensure that the callback is only invoked once
      if (this.messageCallback) {
        this.messageCallback(data);
      }
      // } else if (data.type === 'chat_request_notification') {
      //   console.log(data.message);
      //   alert(data.message);
      // } else {
      //   console.log(data.message);
      //   alert(data.message);
      // }
    };

    this.socket.onclose = (event) => {
      // console.log('WebSocket closed:', event);
      if (event.reason) {
        console.error('Reason for closure:', event.reason);
      }

      // Attempt to reconnect with exponential backoff
      // if (this.reconnectAttempts < this.maxReconnectAttempts) {
      //   setTimeout(() => {
      //     this.reconnectAttempts += 1;
      //     this.reconnectDelay *= 2; // Exponential backoff
      //     console.log(`Reconnecting attempt ${this.reconnectAttempts}`);
      //     this.connect(accessToken, receiverUsername, senderUsername);
      //   }, this.reconnectDelay);
      // } else {
      //   console.error('Max reconnection attempts reached.');
      // }
    };

    this.socket.onerror = (error) => {
      // console.error('WebSocket error:', error);
    };
  }

  disconnect() {
    if (this.socket) {
      console.log('WebSocket disconnected', this.socket);
      this.socket.close();
      this.socket = null;
      this.senderUsername = null;
    }
  }

  sendMessage(message, threadId) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      const data = {
        message: message,
        thread_id: threadId,
      };
      console.log('Sending WebSocket message:', JSON.stringify(data));
      this.socket.send(JSON.stringify(data));

      // Do not trigger the callback here to avoid duplication in the receiver's UI
    } else {
      console.error('WebSocket is not open. Cannot send message.');
    }
  }

  onMessage(callback) {
    this.messageCallback = callback;
  }
}

export default new WebSocketService();
